import { render } from "./floating-buttons-home.vue?vue&type=template&id=cba4c116&scoped=true"
import script from "./floating-buttons-home.vue?vue&type=script&lang=js"
export * from "./floating-buttons-home.vue?vue&type=script&lang=js"

import "./floating-buttons-home.vue?vue&type=style&index=0&id=cba4c116&scoped=true&lang=css"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba4c116"]])

export default __exports__